import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom";
import { Container, Row, Col, NavDropdown, Navbar, Nav, Breadcrumb, Table, Tabs, Tab, Modal, Button, Form } from 'react-bootstrap';
import { Initial } from 'react-initial'
import ReactPaginate from 'react-paginate';
import DataTable from 'react-data-table-component';
import { formatTime, getFlexClasses, getInstructorDetails, getInstructorList, getLanguage, getInstructorDetailsWithSchedule } from '../../Utils/utils';
import moment from "moment-timezone";
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@mui/material/LinearProgress';
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';
import LoadingSpinner from "../LoadingSpinner";
import Select from 'react-select';
import { ToastContainer } from "react-toastify";
import axios from "axios";
import config from "../../config/config";
import { getStartDate } from "../../Utils/dates";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";

const SetupEditModal = (props) => {

  const { showModal, setShowModal, lang_id, setIsSetup, setCloseRow, selectedRow, setSelectedRow, closeRow, showTime, newInstArr, fromGrouped, availableArray, onProceed } = props;
  const [showInstDetail, setShowInstDetail] = useState(false);
  const [isNoInst, setIsNoInst] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [instList, setInstList] = useState([]);
  const [tempInstructorName, setTempInstructorName] = useState('');
  const [instVal, setInstVal] = useState('');
  const [instDetail, setInstDetail] = useState('');
  const [isInstructorAccepted, setIsInstructorAccepted] = useState(selectedRow.instructorAccepted != null ? true : false);
  const [isDisable, setIsDisable] = useState(true);
  const [isDisableBtn, setIsDisableBtn] = useState(true);
  const [selectedTimings, setSelectedTimings] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [newDate, setNewDate] = useState(new Date());

  const startValueRef = useRef({
    instructorAccepted: selectedRow.instructorAccepted,
    instructor: selectedRow?.instructorId,
  });

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const getInstructor = async () => {
    var temp = []
    var res = await getInstructorList(lang_id, selectedRow?.mainClassNumber)
    res.map((e) => {
      temp.push({
        value: e.id, label: e.first_name + ' ' + e.last_name, language_id: e.select_language
      })
    })
    setInstList(temp)
  }

  useEffect(() => {
    console.log(selectedRow, " 231231231");
    getInstructor()
  }, [lang_id])

  // const getInstructorDetail = async (val, lang) => {
  //     if(val != "-2"){
  //       var res = await getInstructorDetails(val, lang)
  //       if (res.status == 200) {
  //         setInstDetail(res.data.data);
  //       }
  //     }else{
  //       setInstDetail('');
  //     }

  //   }

  // useEffect(() => {

  //   if (instVal !== "") {
  //     getInstructorDetail(instVal.value, instVal.language_id)
  //   }
  // }, [instVal])

  const getInstructorDetail = async (val, lang) => {
    if (val != "-2") {
      var res = await getInstructorDetailsWithSchedule(val, lang, selectedRow?.newMatchedTimings, selectedRow?.mainClassNumber, selectedRow?.availableStartDate)
      if (res.status == 200) {
        setInstDetail(res.data.data);
        let updatedSchedule = res?.data?.data?.updated_schedule || [];

        if (val !== selectedRow?.instructorId) {
          updatedSchedule = updatedSchedule.map(t => ({
            ...t,
            isSelected: false
          }));
        }
        setSelectedTimings(updatedSchedule || []);
      }
    } else {
      setInstDetail('');
    }

  }

  useEffect(() => {
    if (instVal !== "") {
      getInstructorDetail(instVal.value, instVal.language_id)
    }
  }, [instVal])

  const saveSetup = async () => {

    setShowModal(false)
    setIsSetup(true)

    if (instVal?.value == -2) {
      selectedRow.instructorName = tempInstructorName
      selectedRow.instructorId = -2
      selectedRow.instructorEmail = ""
      selectedRow.instructorAccepted = false
      selectedRow.isReadyToApprove = true
      selectedRow.newMatchedTimings = selectedTimings;
      selectedRow.availableStartDate = moment(startDate).format("YYYY-MM-DD");
    } else {
      selectedRow.instructorName = `${instDetail?.first_name} ${instDetail?.last_name}`
      selectedRow.instructorId = instDetail?.id
      selectedRow.instructorEmail = `${instDetail?.email}`
      selectedRow.instructorAccepted = isInstructorAccepted
      selectedRow.isReadyToApprove = true
      selectedRow.newMatchedTimings = selectedTimings;
      selectedRow.availableStartDate = moment(startDate).format("YYYY-MM-DD");
    }
    setSelectedRow(selectedRow);
    onProceed()
  }


  const changeInstructorAccept = async (value) => {
    selectedRow.instructorAccepted = value
  }

  useEffect(() => {
    if (selectedRow?.instructorId !== null) {
      if (selectedRow?.instructorId == -2) {
        setShowInstDetail(false)
        setTempInstructorName(selectedRow?.instructorName)
      } else {
        setShowInstDetail(true)
        getInstructorDetail(selectedRow?.instructorId, selectedRow.language?.id)
      }



      setIsDisable(false)
      setInstVal({
        value: selectedRow?.instructorId,
        language_id: selectedRow.language?.id,
        label: selectedRow.instructorName
      });

      // console.log(selectedRow, "123123");
      if (selectedRow?.instructorId == "-2") {
        setSelectedTimings(selectedRow?.newMatchedTimings || []);
      }

      const today = moment().startOf("day");
      const available = moment(selectedRow?.availableStartDate).startOf("day");
      const finalDate = available.isAfter(today) ? available : today;
      setNewDate(new Date(finalDate))
    }
  }, [selectedRow])

  useEffect(() => {
    setStartDate(getStartDate(selectedTimings, newDate));
  }, [selectedTimings]);

  const newSelectedDate = (date) => {
    setNewDate(date)
    setStartDate(getStartDate(selectedTimings, date))
    toast.success("Your class start date has been updated based on your selected class days. Click on Save Changes to apply the update.")
  }

  const allValues = (isInstructorAccepted != startValueRef.current.instructorAccepted || startValueRef.current.instructor != instVal?.value)

  // console.log(selectedRow, "111111111111111")
  // console.log(instDetail, "instDetail......")


  return (
    <>
      <div>
        <ToastContainer
          position="top-center"
        />
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="md" show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title> Select Class Times </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Row>
              <Col md={6}>
                <div className="modal-select">
                  <Select
                    value={instList.find(inst => inst.value === instVal?.value) || null}
                    name="colors"
                    options={instList}
                    className="basic-multi-select "
                    classNamePrefix="select"
                    placeholder="Please select instructor"
                    onChange={(e) => {
                      setIsDisable(false)
                      setInstVal(e)
                      if (e.value == -2) {
                        setShowInstDetail(false)
                      } else {
                        setShowInstDetail(true)
                      }
                    }}
                  />
                </div>
              </Col>
              {instVal?.value == "-2" ?
                <Col md={6}>
                  <div className="mb-3">
                    <input className="form-control mb-2" type="text" name="text"
                      placeholder={("Enter instructor name")} value={tempInstructorName} onChange={(e) => setTempInstructorName(e.target.value)}
                    />
                  </div>
                </Col> : null}
            </Row>

            {showInstDetail == true ?
              <>
                <Row className="mb-2 mt-3">
                  <Col md={4}>
                    <div className="inst-det">
                      First Name:
                    </div>
                  </Col>
                  <Col md={8}>
                    <div className="inst-dets">
                      {instDetail?.first_name}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col md={4}>
                    <div className="inst-det">
                      Last Name:
                    </div>
                  </Col>
                  <Col md={8}>
                    <div className="inst-dets">
                      {instDetail?.last_name}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col md={4}>
                    <div className="inst-det">
                      Phone number:
                    </div>
                  </Col>
                  <Col md={8}>
                    <div className="inst-dets">
                      {instDetail?.phone}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col md={4}>
                    <div className="inst-det">
                      Email:
                    </div>
                  </Col>
                  <Col md={8}>
                    <div className="inst-dets" style={{
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                      wordBreak: 'break-word',
                    }}>
                      {instDetail?.email}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col md={4}>
                    <div className="inst-det">
                      Work Schedule:
                    </div>
                  </Col>
                  <Col md={8}>
                    <div className="inst-dets"
                      style={{
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                        wordBreak: 'break-word',
                      }}
                    >
                      {instDetail?.days_hours}
                    </div>
                  </Col>
                </Row>
                <Form>
                  <Row className="mb-3 mt-3">
                    <Col md={7}>
                      <Form.Check
                        type={'radio'}
                        name="group1"
                        className="setup"
                        // checked={fromGrouped == 1 ? selectedRow?.instructorAccepted != true ? true : false : null}
                        checked={isInstructorAccepted == false ? true : false}
                        onChange={() => {
                          setIsInstructorAccepted(false)
                          changeInstructorAccept(false)
                        }}
                        label={`Request Instructor Acceptance`}
                        id={`default-radio-1`}
                      />
                    </Col>
                    <Col md={5}>
                      <Form.Check
                        type={'radio'}
                        className="setup"
                        name="group1"
                        //checked={fromGrouped == 1 ? selectedRow?.instructorAccepted == true ? true : false : null}
                        checked={isInstructorAccepted == true ? true : false}
                        //checked={true}
                        onChange={() => {
                          setIsInstructorAccepted(true)
                          changeInstructorAccept(true)
                        }}
                        label={`Instructor Accepted`}
                        id={`default-radio-2`}
                      />
                    </Col>
                  </Row>

                </Form>
              </>
              : null}
            <Row className="mb-2 mt-2">
              <Col md={4}>
                <div className="inst-det">
                  Class Start Date:
                </div>
              </Col>
              <Col md={4}>
                <div className="inst-dets">
                  {/* {
                    moment
                      .tz(selectedRow?.availableStartDate, 'UTC')
                      .isBefore(moment().tz('UTC'), 'day')
                      ? moment().tz('UTC').format('MM/DD/YYYY')
                      : moment.tz(selectedRow?.availableStartDate, 'UTC').format('MM/DD/YYYY')
                  } */}
                  {/* {
                    moment
                      .tz(selectedRow?.availableStartDate)
                      .isBefore(startDate)
                      ? moment(startDate).format('MM/DD/YYYY')
                      : moment.tz(selectedRow?.availableStartDate).format('MM/DD/YYYY')
                  } */}
                  {moment(startDate).format('MM/DD/YYYY')}
                </div>
              </Col>
              <Col md={4}>
                Change date
                <DatePicker selected={new Date()} onChange={(date) => newSelectedDate(date)} minDate={new Date()} customInput={<i className="text-primary fas fa-calendar-alt ml-3" style={{ cursor: "pointer", marginLeft: "6px" }} title="Choose Date">
                </i>} />
              </Col>
            </Row>
            <Form>
              <Row className="mb-3 mt-3">
                {showTime === true ? null :
                  (
                    instDetail?.updated_schedule?.length > 0 ? (
                      // (allValues ? instDetail.updated_schedule : instDetail.updated_schedule.filter((t) => t.isSelected))
                      instDetail.updated_schedule.map((time, index) => {
                        const timee = time.classTime.split('-');
                        const toTime = timee[1].slice(0, -3);
                        return (
                          <Col md={6} className="mb-2" key={index}>
                            <>
                              <input
                                type="checkbox"
                                name={`group${index}`}
                                disabled={time.isConflictWithInstructor || isDisable}
                                className={`setup ${time.isConflictWithInstructor ? "conflict-disabled" : ""}`}
                                // disabled={isDisable}
                                // className={`setup ${isDisable ? "conflict-disabled" : ""}`}
                                id={`default-checkbox-${index}`}
                                checked={selectedTimings[index]?.isSelected}
                                onChange={(e) => {
                                  setIsDisableBtn(false);
                                  // time.isSelected = !time.isSelected;
                                  setSelectedTimings(prev =>
                                    prev.map((t, i) =>
                                      i === index ? { ...t, isSelected: !t.isSelected } : t
                                    )
                                  );
                                }}
                              />
                              <span className="ms-2">{`${time.classDay}: ${formatTime(timee[0], toTime)} EST`}</span>
                            </>
                          </Col>
                        );
                      })
                    ) : selectedRow?.newMatchedTimings !== undefined ? (
                      selectedRow.newMatchedTimings.map((time, index) => {
                        const timee = time.classTime.split('-');
                        const toTime = timee[1].slice(0, -3);

                        return (
                          <Col md={6} className="mb-2" key={index}>
                            <>
                              <input
                                type="checkbox"
                                name={`group${index}`}
                                disabled={isDisable}
                                className="setup"
                                id={`default-checkbox-${index}`}
                                checked={selectedTimings[index]?.isSelected}
                                onChange={(e) => {
                                  setIsDisableBtn(false);
                                  // time.isSelected = !time.isSelected;
                                  setSelectedTimings(prev =>
                                    prev.map((t, i) =>
                                      i === index ? { ...t, isSelected: !t.isSelected } : t
                                    )
                                  );
                                }}
                              />
                              <span className="ms-2">{`${time.classDay}: ${formatTime(timee[0], toTime)} EST`}</span>
                            </>
                          </Col>
                        );
                      })
                    ) : (
                      newInstArr.map((a, index) => {
                        return (
                          <Col md={6} className="mb-2" key={index}>
                            <>
                              <input
                                type="checkbox"
                                name={`group${index}`}
                                disabled={isDisable}
                                className="setup"
                                id={`default-checkbox-${index}`}
                                onChange={(e) => {
                                  setIsDisableBtn(false);
                                }}
                                checked={newInstArr.includes(a)}
                              />
                              {`${a} EST`}
                            </>
                          </Col>
                        );
                      })
                    )
                  )}
              </Row>

            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            {/* {fromGrouped == 1 ? null : */}
            <Button variant="primary"
              // disabled={isDisableBtn}
              disabled={(isInstructorAccepted && !selectedTimings?.some(t => t.isSelected))}
              onClick={() => {
                saveSetup()
              }}>
              Save Changes
            </Button>
            {/* } */}
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default SetupEditModal